import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { Invest } from '@classes/invest/invest';
import { ProviderType } from '@enums/provider-type.enum';
import { InvestService } from '@services/invest.service';
import { ReportService } from '@services/report.service';
import { SimulationService } from '@services/simulation.service';
import { UiService } from '@services/ui.service';
import { AuthService } from '@services/auth.service';
import { SaveInvestComponent } from '../save-invest/save-invest.component';
import { ApiText } from '@classes/api-text';
import { InvestBbc } from '@classes/invest/invest-bbc/invest-bbc';
import { InvestSic } from '@classes/invest/invest-sic/invest-sic';

@Component({
    selector: 'app-invest-eval',
    templateUrl: './invest-eval.component.html',
    styleUrls: ['./invest-eval.component.scss']
})
export class InvestEvalComponent implements OnInit, OnDestroy {
    private investSub: Subscription;

    invest: Invest;
    isProcessing: boolean;
    provider: ProviderType;
    providerType = ProviderType;

    constructor(
        private investSrv: InvestService,
        private reportSrv: ReportService,
        private simulationSrv: SimulationService,
        private router: Router,
        private uiSrv: UiService,
        private dialog: MatDialog,
        private authSrv: AuthService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
        this.provider = this.authSrv.getDecodedToken().provider_category;
    }

    onSave(isUpdate: boolean): void {
        this.openDialog(this.invest.text)
        .afterClosed()
        .subscribe((text: ApiText) => {
            if(text) {
                this.invest.text = text;

                if(isUpdate) {
                    this.putInvest();
                } else {
                    this.postInvest();
                }
            }
        });
    }

    onExport(): void {
        this.isProcessing = true;

        this.reportSrv.generateXlsFromInvest(this.invest)
        .subscribe(() => {
            this.isProcessing = false;
        });
    }

    private postInvest(): void {
        this.isProcessing = true;
        this.investSrv.post(this.invest)
        .subscribe(investFromSrv => {
            this.afterSave(investFromSrv.simulation.code);
        },
        () => {
            this.isProcessing = false;
        });
    }

    private putInvest(): void {
        this.isProcessing = true;
        this.investSrv.put(this.invest)
        .subscribe(investFromSrv => {
            this.afterSave(investFromSrv.simulation.code);
        },
        () => {
            this.isProcessing = false;
        });
    }

    private openDialog(text: ApiText): MatDialogRef<SaveInvestComponent> {
        const projectCount =(this.invest as InvestBbc)?.projects?.length
            ?? (this.invest as InvestSic)?.fundingProject?.projects?.length ?? 0;

        return this.dialog.open(SaveInvestComponent, {
          data: {text: ApiText, hasProject: projectCount > 0}
        });
    }

    private afterSave(simulationCode: string): void {
        this.isProcessing = false;
        this.uiSrv.showSnackbar('invest.eval.saved.summary', true);

        this.simulationSrv.get(simulationCode)
        .subscribe(() => {
            this.router.navigate(['/simulation/live']);
        });
    }

    private initSubscriptions(): void {
        this.investSub = this.investSrv.investChanged
        .subscribe(invest => {
            this.invest = invest;
        });
    }

    ngOnDestroy(): void {
        if(this.investSub) {
            this.investSub.unsubscribe();
        }
    }
}
